import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Menu from '../menu/Menu';
import RTButton from '../common/RTButton';
import '../common/rtCommon.css';

const CreateRentInvoices = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="rt-layout">
      <Menu className="rt-menu" activePath={location.pathname} />
      <div className="rt-main-content">
        <div className="rt-title-row">
          <h2 className="rt-title">Create Rent Invoices</h2>
          <div className="rt-actions">
            <RTButton variant="secondary" onClick={() => navigate(-1)}>
              &#8592; Back
            </RTButton>
          </div>
        </div>
        <div className="rt-main-section">
          {/* Main content goes here */}
        </div>
      </div>
    </div>
  );
};

export default CreateRentInvoices;